package org.wordsapp.data

import io.ktor.client.*

actual fun createPlatformHttpClient(config: HttpClientConfig<*>.() -> Unit): HttpClient =
    HttpClient(config)
